// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CustomAppState } from "@west/App/Store/Reducers";

export function getProductListVariantChildrenDataView(state: ApplicationState, parentProductId: string | undefined) {
    if (!parentProductId) {
        return;
    }

    return (state as CustomAppState).xProductListVariantChildren.variantChildren[parentProductId];
}

export function getProductVariantChild(state: ApplicationState, parentProductId?: string) {
    if (!parentProductId) {
        return;
    }

    const variantSelection = (state as CustomAppState).xProductListVariantSelection.variantSelection?.[parentProductId];
    const variantTraitId = variantSelection?.variantTraitId;

    const traitValueId = variantTraitId ? variantSelection?.[variantTraitId] : Object.values(variantSelection)?.[0];

    const product = (state as CustomAppState).xProductListVariantChildren.variantChildren[
        parentProductId
    ]?.products?.find(product => {
        return !!product.childTraitValues?.find(childTrait => childTrait.id === traitValueId);
    });

    return product;
}

export function getProductInfosByProductIdForVariantChild(state: ApplicationState, parentProductId?: string) {
    if (!parentProductId) {
        return;
    }
    const product = getProductVariantChild(state, parentProductId);

    return product
        ? (state as CustomAppState).xProductListVariantChildren.variantChildren[parentProductId]
              ?.productInfosByProductId[product.id]
        : undefined;
}
